import React, { Component } from "react";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import LoadingCircular from "../LoadingCircular";

class News extends Component {
  state = {
    news: [],
    isLoading: false,
  };
  async componentDidMount() {
    this.setState({ isLoading: true });
    const res = await fetch(`/ng/api/GetNews/List`);
    const data = await res.json();
    this.setState({ news: data, isLoading: false });
  }
  render() {
    const { news, isLoading } = this.state;
    const { handleComToShow, handleNewsDetail } = this.props;
    return (
      <>
        <LoadingCircular open={isLoading} />
        <Divider sx={{ mt: 1, mb: 1 }}>اخبار</Divider>
        <List>
          {news.map((news, index) => (
            <Paper
              sx={{ margin: 1, backgroundColor: "#2e2d2b" }}
              variant="outlined"
            >
              <ListItem
                key={index}
                onClick={() => {
                  handleNewsDetail(news.Id);
                  handleComToShow("newsdetail");
                }}
              >
                <ListItemText primary={news.Title} />
              </ListItem>
            </Paper>
          ))}
        </List>
      </>
    );
  }
}

export default News;
